import { Dispatch, SetStateAction } from 'react';
import { SectionOptionType, TrajetoSelecaoIda, TrajetoSelecaoVolum, TrajetosIda, TrajetosVolum, ValeTransp } from '../../../../types';
import Header from './components/Header';
import Route from './components/Route';
import { Container } from './styles';
import { ViewType } from './types';

interface ISidebarRoute {
  view: ViewType;
  handleViewChange: (view: ViewType) => void;
  goingRoute: TrajetoSelecaoIda[];
  returningRoute: TrajetoSelecaoVolum[];
  otherGoingOptions: TrajetosIda[];
  otherReturningOptions: TrajetosVolum[];
  setChangeGoingOptionModalShow: Dispatch<SetStateAction<boolean>>;
  setChangeReturningOptionModalShow: Dispatch<SetStateAction<boolean>>;
  tickets: ValeTransp[];
  canShowTicketsTab: boolean;
  isConsultValid: boolean;
  handleSelectedSectionChange: (selectedSection: SectionOptionType) => void,
  sectionOptions: SectionOptionType[],
  selectedSection: SectionOptionType,
  totalVt: number;
  isMultiRoute: boolean;
}

export default function SidebarRoute({
  view,
  handleViewChange,
  goingRoute,
  returningRoute,
  otherGoingOptions,
  otherReturningOptions,
  setChangeGoingOptionModalShow,
  setChangeReturningOptionModalShow,
  tickets,
  canShowTicketsTab,
  isConsultValid,
  handleSelectedSectionChange,
  sectionOptions,
  selectedSection,
  totalVt,
  isMultiRoute,
}: ISidebarRoute) {
  const selectedGoingRoute = otherGoingOptions.find((rt) => !!(rt.trajetoSelecionado) && (!rt.sequenciaTrajeto || rt.sequenciaTrajeto === selectedSection.value))!;
  const selectedReturningRoute = otherReturningOptions.find((rt) => !!(rt.trajetoSelecionado))!;

  return (
    <Container>
      <Header
        handleViewChange={handleViewChange}
        view={view}
        selectedGoingRoute={selectedGoingRoute}
        selectedReturningRoute={selectedReturningRoute}
        setChangeGoingOptionModalShow={setChangeGoingOptionModalShow}
        setChangeReturningOptionModalShow={setChangeReturningOptionModalShow}
        canShowTicketsTab={canShowTicketsTab}
        isConsultValid={isConsultValid}
        handleSelectedSectionChange={handleSelectedSectionChange}
        sectionOptions={sectionOptions}
        selectedSection={selectedSection}
        isMultiRoute={isMultiRoute}
      />
      <Route
        goingRoute={goingRoute}
        returningRoute={returningRoute}
        tickets={tickets}
        view={view}
        totalVt={totalVt}
      />
    </Container>
  );
}
